export const SENTRY_DSN =
  "https://959a52f58ff5a3848c3251fc29148552@sentry.in-crypto-we-all-trust.com/2";
